<template>
  <page-layout :title="$t('pagelayout.statement')">
    <div class="balance-history-container" ref="">
      <b-form v-show="true" @submit.prevent="search" class="sticky-top">
        <b-row class="d-flex justify-content-md-end">
          <div class="col-md-4 col-12">
            <b-form-group :label="$t('order._duration')">
              <b-input-group>
                <b-form-datepicker
                  :dark="dark"
                  reset-button
                  reset-value="''"
                  :label-reset-button="$t('helper.clear')"
                  reset-button-variant="outline-primary"
                  :placeholder="$t('helper.start-date')"
                  v-model="filters.from"
                  class="datepicker"
                  />
                  <b-form-datepicker
                    :dark="dark"
                    reset-button
                    reset-value="''"
                    :label-reset-button="$t('helper.clear')"
                    reset-button-variant="outline-primary"
                    :placeholder="$t('helper.end-date')"
                    v-model="filters.to"
                    class="datepicker"
                    />
                    <b-input-group-append>
                      <b-button type="submit" class="card-button mt-0">{{ $t('helper.search') }}</b-button>
                    </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-row>
                </b-form>
                <b-row class="d-flex justify-content-center mx-2">
                  <b-col class="col-md-12">
                    <table v-if="items" class="table default-table">
                      <thead>
                        <th>№</th>
                        <th>{{ $t('account.financial-date') }}</th>
                        <th>{{ $t('account.credit') }}</th>
                        <th>{{ $t('account.debit') }}</th>
                        <th>{{ $t('account.info') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in items" :key="i">
                          <th>{{ i + 1 }}</th>
                          <th>{{ item.financialDate }}</th>
                          <th>{{ item.credit }}</th>
                          <th>{{ item.debit }}</th>
                          <th>{{ item.info }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
    </div>   
  </page-layout>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import api from '../api/balance';
import PageLayout from '../components/PageLayout';

export default {
  name: 'TDBBalanceHistoryDetail',
  data() {
    return {
      isLoading: false,
      filters: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
      items: [],
    };
  },
  components: {
    'page-layout': PageLayout,
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        const { data } = await api.getTransactions(this.queryHandler(), 'tdb');
        this.items = data.content;
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    search() {
      const query = _.pickBy(this.filters, v => (!_.isEmpty(v) || !!v));
      this.$router.push({ query });
      this.fetchData();
    },
    queryHandler() {
      this.filters = { ...this.filters, ...this.$route.query };
      return _.pickBy(this.filters, v => (!_.isEmpty(v) || !!v));
    },
  }
}
</script>
<style scoped>
  .search-form {
    background-color: #fff;
    z-index: 2;
  }
</style>
